<template>
    <div>
        <vx-card>
            <vs-tabs>
                <vs-tab :label="$t('menuOrganization.personalInformation')" icon="account_circle">
                    <div>
                        <div class="vx-row">
                            <div class="vx-col md:w-3/4 w-full">
                                <!-- Col Header -->
                                <div class="flex items-end mt-6 mb-3">
                                    <feather-icon icon="SidebarIcon" class="mr-2" svgClasses="w-6 h-6" />
                                    <span class="leading-none font-medium fsz font-bold">Đơn vị - Lớp</span>
                                </div>

                                <div class="vx-row">
                                    <div class="vx-col md:w-1/3 sm:w-auto w-full mt-2">
                                        <label class="vs-input--label">{{ $t('navMenu.school') }} </label>
                                        <span class="text-danger">*</span>
                                        <v-select class="" v-model="branchModel" :clearable="false"
                                            :options="branchOptions" data-vv-validate-on="blur" v-validate="'required'"
                                            name="branch">
                                            <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>
                                        </v-select>
                                        <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
                                    </div>
                                    <div class="vx-col w-full md:w-1/3 mt-2" v-if="studentInfo.organizationBranchId">
                                        <label class="vs-input--label">{{ $t('classRoom.classRoom') }}</label>
                                        <v-select v-model="selected" label="title" :options="classRoomOptions" multiple>
                                            <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>
                                        </v-select>
                                        <span class="text-danger text-sm">{{ errors.first('workDayOfWeek') }}</span>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full flex mt-8" v-if="isUpdate">
                                        <vs-checkbox v-model="studentInfo.enabled" class="mb-1"></vs-checkbox>
                                        <span class="mt-2">Đi học</span>
                                    </div>
                                    <div class="vx-col md:w-2/3 w-full mt-2">
                                        <label class="vs-input--label">Niên khóa</label>
                                        <div class="flex gap-2 gap-x-8">
                                            <vs-input class="w-1/2" v-model="studentInfo.startYear"
                                                v-validate="'numeric'" placeholder="Năm bắt đầu"
                                                name="startYear"></vs-input>
                                            <vs-input class="w-1/2" v-model="studentInfo.endYear" v-validate="'numeric'"
                                                placeholder="Năm kết thúc" name="endYear"></vs-input>
                                        </div>
                                        <div class="flex">
                                            <span class="text-danger text-sm">{{ errors.first('startYear') }}</span>
                                            <span class="text-danger text-sm">{{ errors.first('endYear') }}</span>
                                        </div>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full flex mt-8">
                                        <vs-checkbox v-model="studentInfo.isGraduated" class="mb-1"></vs-checkbox>
                                        <span class="mt-2">Tốt nghiệp</span>
                                    </div>
                                </div>

                                <div class="vx-row mt-4 ml-0" v-if="classTranferHistory.length > 0">
                                    <div class="vx-col md:w-1/3 w-full"></div>
                                    <div class="vx-col md:w-1/3 w-full">
                                        <vs-button @click="openPopupHistory = true" size="small">Lịch sử</vs-button>
                                        <vs-popup :active.sync="openPopupHistory" title="Lịch sử chuyển lớp"
                                            class="top-popup">
                                            <div class="vx-row">
                                                <div class="vx-col md:w-1/4 w-full">
                                                    <b>Tên lớp</b>
                                                </div>
                                                <div class="vx-col md:w-1/4 w-full">
                                                    <b>Ngày bắt đầu</b>
                                                </div>
                                                <div class="vx-col md:w-1/4 w-full">
                                                    <b>Ngày kết thúc</b>
                                                </div>
                                                <div class="vx-col md:w-1/4 w-full">
                                                    <b>Trạng thái</b>
                                                </div>
                                            </div>
                                            <vs-divider />
                                            <div v-for="(item, index) in classTranferHistory" :key="index"
                                                class="mt-2 mb-2">
                                                <div class="vx-row">
                                                    <div class="vx-col md:w-1/4 w-full">
                                                        <span class="">{{ item.className }}</span>
                                                    </div>
                                                    <div class="vx-col md:w-1/4 w-full">
                                                        <span>{{ item.startDate }}</span>
                                                    </div>
                                                    <div class="vx-col md:w-1/4 w-full">
                                                        <span>{{ item.endDate }}</span>
                                                    </div>
                                                    <div class="vx-col md:w-1/4 w-full">
                                                        <vs-chip class="ag-grid-cell-chip"
                                                            :color="chipColor(item.status)">
                                                            <span>{{ statusClassString(item.status) }}</span>
                                                        </vs-chip>
                                                    </div>
                                                </div>
                                            </div>
                                        </vs-popup>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col md:w-1/4 sm:w-auto w-full">
                                <div class="text-center mb-4">
                                    <feather-icon icon="MaximizeIcon" class="mr-2" svgClasses="w-6 h-6"
                                        style="vertical-align: sub;" />
                                    <span class="leading-none font-medium fsz font-bold">{{
                    $t('menuCustomer.faceData')
                }}</span>
                                </div>
                                <div class="flex justify-center">
                                    <vue-upload-multiple-image @upload-success="uploadImageSuccess"
                                        @before-remove="beforeRemove" @edit-image="editImage" @data-change="dataChange"
                                        :data-images="images"
                                        :dragText="$t('menuOrganization.dragText')"></vue-upload-multiple-image>
                                </div>
                            </div>
                        </div>

                        <div class="vx-row mt-4">
                            <div class="vx-col w-full">
                                <!-- Col Header -->
                                <div class="flex items-end mt-8 mb-3">
                                    <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-6 h-6" />
                                    <span class="leading-none font-medium fsz font-bold">Lý lịch - Liên hệ</span>
                                </div>
                                <div class="vx-row">
                                    <!--                                    <div class="vx-col md:w-1/3 w-full mt-2">-->
                                    <!--                                        <label class="vs-input&#45;&#45;label">{{$t('menuOrganization.studentCode')}} <span class="text-danger">*</span></label>-->
                                    <!--                                        <vs-input class="w-full" :disabled="isUpdate"-->
                                    <!--                                                v-model="studentInfo.studentCode"-->
                                    <!--                                                v-validate="'required|max:20'" name="studentCode"/>-->
                                    <!--                                        <span class="text-danger text-sm">{{ errors.first('studentCode') }}</span>-->
                                    <!--                                    </div>-->
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.lastName') }} <span
                                                class="text-danger">*</span></label>
                                        <vs-input class="w-full" v-model="studentInfo.lastName" v-validate="'required'"
                                            name="lastName" />
                                        <span class="text-danger text-sm">{{ errors.first('lastName') }}</span>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.firstName') }} <span
                                                class="text-danger">*</span></label>
                                        <vs-input class="w-full" v-model="studentInfo.firstName" v-validate="'required'"
                                            name="firstName" />
                                        <span class="text-danger text-sm">{{ errors.first('firstName') }}</span>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.birthday') }} <span
                                                class="text-danger">*</span></label>
                                        <flat-pickr v-model="birthDay" v-validate="'required'" :config="dateConfig"
                                            name="birthday" placeholder="DD/MM/YYYY" class="w-full" />
                                        <span class="text-danger text-sm">{{ errors.first('birthday') }}</span>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.phoneNumber') }}</label>
                                        <vs-input class="w-full" v-model="studentInfo.phoneNumber"
                                            v-validate="{ regex: /(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/ }"
                                            name="phoneNumber" />
                                        <span class="text-danger text-sm">{{ errors.first('phoneNumber') }}</span>
                                    </div>
                                    <div class="vx-col w-full md:w-1/4 mt-2">
                                        <label class="vs-input--label">{{ $t('menuOrganization.gender') }} </label>
                                        <div class="mt-2 ml-1">
                                            <vs-radio v-model="studentInfo.gender" vs-value="0" class="mr-4">Chưa xác
                                                định
                                            </vs-radio>
                                            <vs-radio v-model="studentInfo.gender" vs-value="1" class="mr-4">Nam
                                            </vs-radio>
                                            <vs-radio v-model="studentInfo.gender" vs-value="2">Nữ</vs-radio>
                                        </div>
                                        <span class="text-danger text-sm">{{ errors.first('gender') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Col Header -->
                        <div class="flex items-end mt-10 mb-3">
                            <feather-icon icon="MapPinIcon" class="mr-2" svgClasses="w-6 h-6" />
                            <span class="leading-none font-medium fsz font-bold">Địa chỉ</span>
                        </div>



                        <!--                        <div class="vx-row">-->
                        <!--                            <div class="vx-col md:w-1/3 w-full mt-2">-->
                        <!--                                <label class="vs-input&#45;&#45;label">{{ $t('menuOrganization.city') }} </label>-->
                        <!--                                <v-select class="heightDropdown" v-model="province" :clearable="false"-->
                        <!--                                          :options="cityOptions"-->
                        <!--                                          data-vv-validate-on="blur" name="city">-->
                        <!--                                    <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>-->
                        <!--                                </v-select>-->
                        <!--                                <span class="text-danger text-sm">{{ errors.first('city') }}</span>-->
                        <!--                            </div>-->
                        <!--                            <div class="vx-col md:w-1/3 w-full mt-2">-->
                        <!--                                <label class="vs-input&#45;&#45;label">{{ $t('menuOrganization.district') }} </label>-->
                        <!--                                <v-select class="heightDropdown" v-model="district" :clearable="false"-->
                        <!--                                          :options="districtOptions"-->
                        <!--                                          data-vv-validate-on="blur" name="district">-->
                        <!--                                    <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>-->
                        <!--                                </v-select>-->
                        <!--                                <span class="text-danger text-sm">{{ errors.first('district') }}</span>-->
                        <!--                            </div>-->

                        <!--                            <div class="vx-col md:w-1/3 w-full mt-2">-->
                        <!--                                <label class="vs-input&#45;&#45;label">{{ $t('menuOrganization.commune') }} </label>-->
                        <!--                                <v-select class="heightDropdown" v-model="subDistrict" :clearable="false"-->
                        <!--                                          :options="subDistrictOptions"-->
                        <!--                                          data-vv-validate-on="blur" name="subDistrict">-->
                        <!--                                    <span slot="no-options">{{ $t('root.noRowsToShow') }}</span>-->
                        <!--                                </v-select>-->
                        <!--                                <span class="text-danger text-sm">{{ errors.first('subDistrict') }}</span>-->
                        <!--                            </div>-->
                        <!--                        </div>-->

                        <div class="vx-row mt-4">
                            <!--                            <div class="vx-col md:w-1/3 w-full mt-2">-->
                            <!--                                <label class="vs-input&#45;&#45;label">{{ $t('menuOrganization.houseNumber') }}-->
                            <!--                                </label>-->
                            <!--                                <vs-input class="w-full" v-model="studentInfo.houseNumber"-->
                            <!--                                          name="houseNumber"/>-->
                            <!--                                <span class="text-danger text-sm">{{ errors.first('houseNumber') }}</span>-->
                            <!--                            </div>-->
                            <div class="vx-col w-full mt-2">
                                <label class="vs-input--label">{{ $t('menuOrganization.address') }} </label>
                                <vs-input class="w-full" v-model="studentInfo.fullAddress" v-validate="''"
                                    name="address" />
                            </div>
                        </div>
                        <div class="vx-row">
                            <h3 class="ml-2 mt-6">{{ $t('menuOrganization.workingTime') }}</h3>
                        </div>
                        <div class="vx-row md:mb-1 mb-4 mt-4" v-for="(item, index) in workShiftSetting" :key="index">
                            <div class="vx-col lg:w-1/2 w-full">
                                <vs-checkbox v-model="item.select" class="mb-1">{{
                    item.displayWorkShift
                }}
                                </vs-checkbox>
                            </div>

                            <div class="vx-col lg:w-1/4 w-full">
                                <vs-checkbox v-model="item.autoGenerateWorkShift" class="mb-1">{{
                    $t('menuOrganization.autoGenerate')
                }}
                                </vs-checkbox>
                            </div>
                        </div>

                        <!-- Save & Reset Button -->
                        <div class="vx-row mt-4">
                            <div class="vx-col w-full">
                                <div class="flex flex-wrap items-center justify-end">
                                    <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm"
                                        v-if="isPermissionEdit()">{{
                    `${isUpdate ?
                        $t('button.update') : $t('button.create')}`
                }}
                                    </vs-button>
                                    <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)"
                                        v-if="!studentId">
                                        {{ $t('button.back') }}
                                    </vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </vs-tab>
                <vs-tab :label="$t('menuOrganization.rePass')" icon="locks" v-show="isUpdate">
                    <div v-if="isUpdate">
                        <div class="vx-row mt-4">
                            <div class="vx-col md:w-1/4 w-full sm:w-auto">
                                <label class="vs-input--label">Tài khoản</label>
                                <vs-input class="w-full" disabled v-model="studentInfo.username" />
                            </div>
                            <div class="vx-col md:w-1/4 w-full sm:w-auto">
                                <label class="vs-input--label">Mật khẩu</label>
                                <span class="text-sm text-danger">*</span>
                                <vs-input class="w-full" v-model="newPassword" v-validate="'required|min:6'"
                                    name="newPassword" />
                                <span class="text-danger text-sm">{{ errors.first('newPassword') }}</span>
                            </div>
                            <!-- <div class="vx-col md:w-1/4 w-full sm:w-auto">
                                <vs-button class="mt-6" color="primary" @click="resetPassword">Đặt lại mật khẩu</vs-button>
                            </div> -->
                        </div>

                        <div class="mt-4">
                        </div>
                        <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full">
                                <div class="vx-row">
                                    <div class="vx-col w-full">
                                        <vs-button class="mt-2" color="primary" @click="resetPassword">Đặt lại mật
                                            khẩu
                                        </vs-button>
                                    </div>
                                </div>
                                <div class="vx-row mt-2">
                                    <div class="vx-col w-full">
                                        <small class="text-danger">Đặt lại về mật khẩu mặc định (admin123456)</small>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                                <div class="flex flex-wrap items-center justify-end">
                                    <vs-button class="ml-auto mt-2" @click="changePassword" :disabled="!validateForm"
                                        v-if="isPermissionEdit()">{{ $t('button.update') }}
                                    </vs-button>
                                    <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)"
                                        v-if="!studentId">
                                        {{ $t('button.back') }}
                                    </vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </vs-tab>
            </vs-tabs>
        </vx-card>

    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import CardCustomer from '../card-customer/card/CardCustomer.vue'
import vSelect from 'vue-select'
import province from '@/assets/utils/province.js';
import Datepicker from 'vuejs-datepicker';
import utils from "../../../components/utils";
import VueUploadMultipleImage from '../../../components/VueUploadMultipleImage'
import { en, vi } from 'vuejs-datepicker/dist/locale'
import moment from 'moment';
import { AgGridVue } from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import { isRouter } from '../../../store/permission';
import { constRouter } from '../../../store/constant';
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Vietnamese } from 'flatpickr/dist/l10n/vn.js';

export default {
    components: {
        vSelect,
        Datepicker,
        VueUploadMultipleImage,
        // TitleScreen,
        CardCustomer,
        AgGridVue,
        FlatPickr
    },
    props: {
        branchId: {
            type: Number,
            default: null,
        },
        studentId: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            openPopupHistory: false,
            selected: [],
            classRoomOptions: [],
            activePopup: false,
            cardCustomer: {
                cardId: null
            },
            dateConfig: {
                dateFormat: 'd/m/Y',
                allowInput: true,
                locale: Vietnamese,
            },
            listCards: [],
            checkUsernameExisted: true,
            isMaxLength: false,
            highlighted: {
                dates: [
                    new Date()
                ]
            },
            userInfo: {},
            en: en,
            vi: vi,
            departmentName: null,
            isCreateDepartment: false,
            isShowManagerDepartment: true,
            departmentOptions: [],
            isShowPermission: false,
            permissions: [],
            privileges: [],
            images: [],
            imagesId: [],
            isUpdateImages: false,
            user_data: null,
            activeTab: 0,
            isUpdate: false,
            isUpdateFace: false,
            branchOptions: [],
            studentInfo: {
                cardNumber: null,
                cardStaffType: null,
                firstName: null,
                lastName: null,
                username: null,
                organizationBranchId: null,
                city: null,
                district: null,
                street: null,
                enabled: true,
                isGraduated: false,
                classIds: [],
                startYear: null,
                endYear: null,
                images: null,
                workShiftSetting:null,
            },
            birthDay: null,
            workShiftSetting: [],
            newPassword: null,
            employeeTypeOptions: [
                { value: 0, label: this.$t('employeeTypeOptions.unknown') },
                { value: 1, label: this.$t('employeeTypeOptions.trainee') },
                { value: 2, label: this.$t('employeeTypeOptions.officialStaff') }
            ],
            cityOptions: province.getProvince(),
            districtOptions: [],
            subDistrictOptions: [],
            file: [],
            fileName: this.$t('menuOrganization.addFace'),
            uploadPercent: 0,
            disabledFn: {
                customPredictor(date) {
                    if (moment(date).isAfter(moment(), 'days')) {
                        return true;
                    }
                }
            },
            classTranferHistory: [],
            workShiftSetting: [],
        }
    },
    async created() {
        // this.initScreen();
        let userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.userInfo = userInfo;
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.filter(x => x.organizationBranchType === 3).map(x => {
            return { label: x.organizationBranchName, value: x.id }
        });

        let route = this.$route.query;
        if ((route && route.id && route.branch_id) || (this.branchId && this.studentId)) {
            this.studentInfo.organizationBranchId = route.branch_id ? parseInt(route.branch_id) : parseInt(this.branchId);
            await this.getClassRoom();
            await this.getUserInfo(route.id ? route.id : this.studentId);
            if (this.studentInfo.imageStore.length > 0) {
                for (const x of this.studentInfo.imageStore) {
                    let data = await this.toDataURL(x.url);
                    let dataImage = data.xhr.response;
                    let metadata = {
                        type: 'image/jpeg'
                    };
                    let file = new File([dataImage], x.fileName, metadata);
                    this.images.push({
                        name: x.fileName,
                        path: data.imgBase64,
                        highlight: 1,
                        default: 1,
                        file: file
                    });
                }
            }
        } else {
            this.branchModel = this.branchOptions[0]
        }
        if (!this.isUpdate) this.studentInfo.gender = 0;
        this.formatUnixTime();
        if (this.studentInfo.birthday) this.birthDay = this.studentInfo.birthday
        this.loadWorkShiftSetting()
    },
    computed: {
        branchModel: {
            get() {
                return {
                    label: this.getLabelString(this.branchOptions.find(x => x.value == this.studentInfo.organizationBranchId)),
                    value: this.studentInfo.organizationBranchId
                }
            },
            set(obj) {
                this.studentInfo.organizationBranchId = obj.value;
                if (obj) this.getClassRoom();
            }
        },
        validateForm() {
            return !this.errors.any()
        },
        province: {
            get() {
                return {
                    label: this.getLabelString(this.cityOptions.find(x => x.value === this.studentInfo.city)),
                    value: this.studentInfo.city
                }
            },
            set(obj) {
                if (obj.value) {
                    this.studentInfo.city = obj.value;
                    this.districtOptions = province.getDistrict(obj.value);
                    this.studentInfo.district = this.districtOptions[0].value;
                    this.subDistrictOptions = province.getSubDistrict(this.studentInfo.city, this.studentInfo.district);
                    this.studentInfo.street = this.subDistrictOptions[0].value;
                } else {
                    this.studentInfo.city = null;
                    this.districtOptions = [{ value: null, label: this.$t('cardCustomer.allCard') }];
                    this.studentInfo.district = null;
                    this.subDistrictOptions = [{ value: null, label: this.$t('cardCustomer.allCard') }];
                    this.studentInfo.street = null;
                }
            }
        },
        district: {
            get() {
                return {
                    label: this.getLabelString(this.districtOptions.find(x => x.value === this.studentInfo.district)),
                    value: this.studentInfo.district
                }
            },
            set(obj) {
                this.studentInfo.district = obj.value;
                this.subDistrictOptions = province.getSubDistrict(this.studentInfo.city, obj.value);
                this.studentInfo.street = this.subDistrictOptions[0].value;
            }
        },
        subDistrict: {
            get() {
                return {
                    label: this.getLabelString(this.subDistrictOptions.find(x => x.value === this.studentInfo.street)),
                    value: this.studentInfo.street
                }
            },
            set(obj) {
                this.studentInfo.street = obj.value
            }
        },
        // fullAddressModel: {
        //     get() {
        //         if (this.province.value) {
        //             let fullAddress = `${this.studentInfo.houseNumber ? this.studentInfo.houseNumber + ', ' : ''}${this.subDistrict.label ? this.subDistrict.label + ', ' : ''}${this.district.label}, ${this.province.label}`;
        //             this.studentInfo.fullAddress = fullAddress;
        //             return fullAddress;
        //         } else {
        //             return null;
        //         }
        //     },
        // },
        chipColor() {
            return (value) => {
                if (value === 1) return "warning";
                return "success";
            }
        },
        statusClassString() {
            return (value) => {
                if (value === 1) return this.$t('employeeScreen.history');
                return this.$t('employeeScreen.on');


            }
        }
    },
    methods: {
        formatUnixTime() {
            const date = new Date(this.studentInfo.birthday);
            if (this.isUpdate) {
                const formatted = `${('0' + date.getDate()).slice(-2)}/${('0' + (date.getMonth() + 1)).slice(-2)}/${date.getFullYear()}`;
                this.studentInfo.birthday = formatted;
            }

        },
        isPermissionEdit() {
            return isRouter(this, constRouter.student_edit)
        },
        getClassRoom() {
            const payload = {
                organizationBranchId: this.studentInfo.organizationBranchId
            }
            return new Promise((resolve, reject) => {
                this.$crm.post('/school-classroom/get-all-class', payload).then((res) => {
                    this.classRoomOptions = res.data.map(el => {
                        return {
                            title: el.className,
                            value: el.id
                        }
                    });
                    resolve(true);
                }).catch((err) => {
                    reject(false);
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        toDataURL(url) {
            return new Promise(resolve => {
                let xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    let reader = new FileReader();
                    reader.onloadend = function () {
                        resolve({ imgBase64: reader.result, xhr: xhr });
                    }
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url, true);
                xhr.responseType = 'blob';
                xhr.send();
            })
        },

        getUserInfo(studentId) {
            this.$vs.loading();
            return new Promise(resolve => {
                this.$vs.loading();
                this.$crm.post('/school-student/find-by-id/' + studentId).then(async (response) => {
                    console.log('jdsd', response.data)
                    this.studentInfo = response.data;
                    this.studentInfo.isGraduated = (this.studentInfo.isGraduated == 1) ? true : false
                    this.classTranferHistory = response.data.schoolClassRoomTransfers.map(x => {

                        x.startDate = moment(x.startDate).format('DD/MM/YYYY')
                        x.endDate = x.endDate ? moment(x.endDate).format('DD/MM/YYYY') : null
                        x.status = x.endDate ? 1 : 0
                        return x
                    })
                    //get class room by id
                    let classRoom = [];
                    if (response.data.classIds && response.data.classIds.length > 0) {
                        response.data.classIds.forEach(roomId => {
                            let room = this.classRoomOptions.find(el => el.value === roomId);
                            if (room) classRoom.push(room);
                        })
                    }
                    for (const x of this.studentInfo.fileManagers) {
                        let data = await this.toDataURL(x.url);
                        let dataImage = data.xhr.response;
                        let metadata = {
                            type: 'image/jpeg'
                        };
                        let file = new File([dataImage], x.fileName, metadata);
                        this.images.push({
                            name: x.fileName,
                            path: data.imgBase64,
                            highlight: 1,
                            default: 1,
                            file: file
                        });
                    }
                    this.selected = classRoom;
                    let dataImage = response.data.fileManagers;
                    if (dataImage && dataImage.length > 0) this.studentInfo.urlImage = dataImage[0].url;
                    this.districtOptions = province.getDistrict(this.studentInfo.city);
                    this.subDistrictOptions = province.getSubDistrict(this.studentInfo.city, this.studentInfo.district);
                    this.isUpdate = true;

                    resolve(true);
                    this.$vs.loading.close();
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        uploadImageSuccess(formData, index, fileList, file) {
            this.images = fileList;
            this.studentInfo.urlImage = fileList.length > 0 ? fileList[0].path : null;
            this.setIsUpdateImages();
        },
        beforeRemove(index, done, fileList) {
            this.images = fileList;
            this.setIsUpdateImages();
            done();
        },
        editImage(formData, index, fileList) {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        dataChange(data) {
            this.images = fileList;
            this.studentInfo.urlImage = data;
            this.setIsUpdateImages();
        },
        setIsUpdateImages() {
            if (this.isUpdate) {
                this.isUpdateImages = true;
            }
        },
        getLabelString(object) {
            return (object && object.label) || this.$t('menuOrganization.null');
        },
        manufactureString(type) {
            let typeString = this.manufactureOptions.find(x => x.value === type);
            return (typeString && typeString.label) || this.$t('menuOrganization.null');
        },
        async saveChanges(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;

            const result = await this.$validator.validateAll();
            if (!result) return;

            if (new Date(this.studentInfo.birthday).getTime() > new Date().getTime()) {
                return this.$vs.notify({
                    title: this.$t('message.error'),
                    text: this.$t('menuOrganization.theFuture'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            const isoBirthday = moment(this.birthDay, "DD/MM/YYYY")._d.toISOString();
            // const isoBirthday = moment(this.birthDay, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm:ss.SSSZ")
            this.studentInfo.birthday = isoBirthday
            //update by school
            // this.studentInfo.departmentType = parseInt(this.studentInfo.departmentType);

            // if (!this.studentInfo.firstName) {
            //     return this.$vs.notify({
            //         text: this.$t('employeeScreen.requiredFirstName'),
            //         iconPack: 'feather',
            //         icon: 'icon-alert-circle',
            //         color: 'danger'
            //     });
            // } else if (!this.studentInfo.lastName) {
            //     return this.$vs.notify({
            //         text: this.$t('employeeScreen.requiredLastName'),
            //         iconPack: 'feather',
            //         icon: 'icon-alert-circle',
            //         color: 'danger'
            //     });
            // } else if (!this.studentInfo.birthday) {
            //     return this.$vs.notify({
            //         text: this.$t('employeeScreen.requiredBirth'),
            //         iconPack: 'feather',
            //         icon: 'icon-alert-circle',
            //         color: 'danger'
            //     });
            // }

            if (this.studentInfo.firstName && this.studentInfo.lastName) {
                this.studentInfo.fullName = this.studentInfo.lastName.trim() + " " + this.studentInfo.firstName.trim();
            }
            this.studentInfo.privileges = this.privileges;

            if (!this.isUpdate || (this.isUpdate && this.isUpdateImages)) {
                if (this.images.length > 0) {
                    await this.handleClickUploadFile();
                    this.studentInfo.images = this.imagesId;
                } else {
                    this.studentInfo.images = []
                }
            }
            if (this.isUpdate){
                if (this.images.length > 0) {
                    await this.handleClickUploadFile();
                    this.studentInfo.images = this.imagesId;
                } else {
                    this.studentInfo.images = []
                }
            }
            // if(this.update){
            //     if(this.images.length > 0){
            //         this.studentInfo.images = [...this.images]
            //         console.log(this.studentInfo.images)
            //     }
            // }
            this.studentInfo.workShiftSetting = this.workShiftSetting.reduce((arr, item) => {
                if (item.select) {
                    arr.push({
                        workShiftSettingId: item.id,
                        autoGenerateWorkShift: item.autoGenerateWorkShift ? 1 : 0
                    });
                }
                return arr;
            }, []);
            this.studentInfo.classIds = this.selected.map(el => el.value);
            this.studentInfo.isGraduated = this.studentInfo.isGraduated ? 1 : 2
            let url = this.isUpdate ? `/school-student/update/${this.studentInfo.id}` : `/school-student/create/${this.studentInfo.organizationBranchId}`,
                data = this.isUpdate ? this.studentInfo : [this.studentInfo];
                // this.images = this.isUpdate 
            this.$vs.loading();
            this.$crm.post(url, data).then(() => {
                this.$vs.notify({
                    color: 'success',
                    text: `${this.isUpdate ? this.$t('button.update') : this.$t('button.create')} ${this.$t('menuOrganization.succStudent')}`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.$vs.loading.close();

                if (this.studentId) {
                    this.$eventBus.$emit("update-student", {});
                } else {
                    this.$router.push('/user/student').catch(() => {
                    })
                }
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        handleClickUploadFile() {
            return new Promise((resolve) => {
                let formData = new FormData(), config = {};
                this.images.forEach((f, i) => {
                    formData.append('files', f.file);
                });
                config = {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                };

                this.$vs.loading();
                let url = this.isUpdate ? `school-student/image/upload?studentId=${this.studentId}` :'school-student/image/upload'
                this.$crm.post(url, formData, config).then((res) => {
                    this.imagesId = [];
                    this.imagesId = res.data;
                    resolve(true);
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            });
        },

        employeeList() {
            this.$router.push(`/user/manage-employee${this.studentInfo.organizationBranchId ? `?branch_id=${this.studentInfo.organizationBranchId}` : ''}`).catch(() => {
            })
        },

        async changePassword(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;

            const result = await this.$validator.validateAll();
            if (!result) return;

            // if (!this.newPassword) {
            //     return this.$vs.notify({
            //         text: 'Mật khẩu là trường bắt buộc !',
            //         color: 'danger',
            //         iconPack: 'feather',
            //         icon: 'icon-alert-circle'
            //     })
            // }

            let body = {
                employeeId: this.studentInfo.id,
                password: this.newPassword
            }

            this.$vs.loading()
            this.$crm.post('/school-student/change-password', body).then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    text: 'Cập nhật mật khẩu thành công !',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: "success"
                })
                if (this.branchId) {
                    this.$eventBus.$emit("update-student", {});
                } else {
                    this.$router.push('/user/student').catch(() => {
                    })
                }
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        resetPassword() {
            let body = {
                employeeId: this.studentInfo.id,
                password: 'admin123456'
            }

            this.$vs.loading()
            this.$crm.post('/school-student/change-password', body).then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    text: 'Đặt lại mật khẩu thành công !',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                })
                this.$eventBus.$emit("update-student", {});
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        loadWorkShiftSetting() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/work-shift/organization/find-by-organization-branch/' + this.studentInfo.organizationBranchId).then((response) => {
                    this.workShiftSetting = response.data.workShiftSetting.map(item => {
                        if (this.isUpdate) {
                            let setting = this.studentInfo.workShiftSetting.find(setting => {
                                return item.id === setting.workShiftSettingId;
                            })
                            if (setting) {
                                item.select = true;
                                item.autoGenerateWorkShift = setting.autoGenerateWorkShift;
                            } else {
                                item.select = false
                                item.autoGenerateWorkShift = false;
                            }
                        } else {
                            item.select = false;
                            item.autoGenerateWorkShift = false;
                        }
                        item.displayWorkShift = "Nhóm " + item.groupName + " - Ca " + item.name + ": " + utils.minuteToHour(item.startHour) + "-" + utils.minuteToHour(item.endHour);
                        return item;
                    });
                    resolve()
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject()
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: this.$t('message.error'),
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
    },
}
</script>

<style lang="scss">
.heightDropdown .vs__dropdown-menu {
    height: 150px !important;
}
</style>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
    &.vs-chip-success {
        background: rgba(var(--vs-success), .15);
        color: rgba(var(--vs-success), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-warning {
        background: rgba(var(--vs-warning), .15);
        color: rgba(var(--vs-warning), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-danger {
        background: rgba(var(--vs-danger), .15);
        color: rgba(var(--vs-danger), 1) !important;
        font-weight: 500;
    }
}

.top-popup {
    z-index: 9999 !important;
}
</style>
